export default __webpack_public_path__ + "static/media/whitebeer.348b2015.jpg";